/* eslint-disable camelcase */
import React from 'react'
import { useTranslation } from 'react-i18next'
import Navbar from 'components/Navbar'
import { PictureGalleries } from 'services'

const Index = ({
  match: {
    params: { audit_id },
  },
}) => {
  const { t } = useTranslation('routes')

  return (
    <>
      <Navbar name={t('routes:audit.edit.photos.index.name')} />
      <PictureGalleries audit_id={audit_id} />
    </>
  )
}

export default Index
